import React, { useRef } from 'react';
import { Spinner, SpinnerSize, FontIcon } from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';

const UploadFile = ({
  isUploading,
  onUploadFiles,
  maxFileSize,
  allowedFileTypes,
  allowMultiple,
}) => {
  const { t: translator } = useTranslation();

  // calculating bytes to megabytes
  const maxFileSizeInMb = maxFileSize / Math.pow(10, 6);

  const onUploadFilesLocal = (event) =>
    event.target.files.length && onUploadFiles(event);

  const onDropFiles = (event) => {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files) {
      const files = event.dataTransfer.files;
      if (files && files.length) {
        onUploadFilesLocal({
          target: {
            files: files,
          },
        });
      }
    }
  };

  const labelRef = useRef(null);
  const onKeyDownLabel = (event) => {
    if (event.key === 'Enter' && labelRef.current) {
      event.preventDefault();
      labelRef.current.click();
    }
  };

  return (
    <div className="appendix-upload">
      <div className="appendix-upload-file">
        <div
          className="appendix-upload-file-box"
          onDrop={onDropFiles}
          onDragOver={(e) => e.preventDefault()}
        >
          <div className="appendix-upload-file-box-icon">
            <FontIcon iconName="Upload" className="icon-class" />
          </div>
          <div className="appendix-upload-file-box-text">
            <p className="upload-file-title">
              {translator('components.fileComponents.uploadFile')}
            </p>
            <br />
            <p>
              <label tabIndex="0" ref={labelRef} onKeyDown={onKeyDownLabel}>
                {translator('components.fileComponents.pickFile')}
                <input
                  id="upload-file-input"
                  type="file"
                  onChange={onUploadFilesLocal}
                  disabled={isUploading}
                  multiple={allowMultiple}
                />
              </label>{' '}
              {translator('components.fileComponents.pickFileExtended')}
            </p>
          </div>
        </div>
        <div className="appendix-upload-file-text">
          <p>
            {translator('components.fileComponents.maxFileSize')}:{' '}
            {`${maxFileSizeInMb} MB`}
          </p>
          {allowedFileTypes && (
            <p>
              {translator('components.fileComponents.allowedFileTypes')}:{' '}
              {allowedFileTypes}
            </p>
          )}
        </div>
        {isUploading ? (
          <div className="appendix-upload-file-spinner">
            <Spinner size={SpinnerSize.large} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export { UploadFile };
